export default __webpack_public_path__ + "static/media/2408.b39b2f4a.png";